import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
var IDENTITY_COOKIE_NAME = 'mb__experiments_id';
var EXPERIMENTS_COOKIE_NAME = 'mb__experiments';
var EXPERIMENTS_COOKIE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

var isLocalEnv = function isLocalEnv() {
  return typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname.endsWith('.ddev.site') || /^\d+\.\d+\.\d+\.\d+$/.test(window.location.hostname));
};

// ============ Identity Cookie Functions ============

export var getExperimentsId = function getExperimentsId() {
  try {
    var match = document.cookie.split(';').map(function (c) {
      return c.trim();
    }).find(function (c) {
      return c.startsWith("".concat(IDENTITY_COOKIE_NAME, "="));
    });
    if (!match) return null;
    var value = match.substring(IDENTITY_COOKIE_NAME.length + 1);
    return value ? decodeURIComponent(value) : null;
  } catch (_unused) {
    return null;
  }
};
export var setExperimentsId = function setExperimentsId(id) {
  if (!id) return;
  try {
    var expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    var domain = isLocalEnv() ? '' : '; domain=.moneyboat.co.uk';
    document.cookie = "".concat(IDENTITY_COOKIE_NAME, "=").concat(encodeURIComponent(id), "; expires=").concat(expires, "; path=/").concat(domain, "; SameSite=Lax");
  } catch (_unused2) {
    // silently fail
  }
};
export var getExperimentsIdWithFallback = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var id, newId;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = getExperimentsId();
          if (!id) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", id);
        case 1:
          newId = "$experiments:".concat(crypto.randomUUID());
          setExperimentsId(newId);
          return _context.abrupt("return", newId);
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getExperimentsIdWithFallback() {
    return _ref.apply(this, arguments);
  };
}();

// ============ Experiments Cookie Functions ============

export var getExperimentsFromCookie = function getExperimentsFromCookie() {
  if (typeof document === 'undefined') return null;
  try {
    var match = document.cookie.split(';').map(function (c) {
      return c.trim();
    }).find(function (c) {
      return c.startsWith("".concat(EXPERIMENTS_COOKIE_NAME, "="));
    });
    if (!match) return null;
    var value = match.substring(EXPERIMENTS_COOKIE_NAME.length + 1);
    if (!value) return null;
    var data = JSON.parse(decodeURIComponent(value));
    if (!(data !== null && data !== void 0 && data.timestamp)) return null;
    // Either bucket alone is a valid cache hit: the new portal (or a stopped
    // experiment) can write an eoe-only cookie, and requiring `experiments`
    // here silently defeats the cache for it.
    if (!(data !== null && data !== void 0 && data.experiments) && !(data !== null && data !== void 0 && data.eoe)) return null;
    if (Date.now() - data.timestamp > EXPERIMENTS_COOKIE_TTL_MS) return null;

    // Normalize: either bucket may be absent depending on which origin wrote it
    return _objectSpread(_objectSpread({}, data), {}, {
      experiments: data.experiments || {},
      eoe: data.eoe || {}
    });
  } catch (_unused3) {
    return null;
  }
};
export var setExperimentsCookie = function setExperimentsCookie(experiments) {
  var eoe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var eligibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (typeof document === 'undefined') return;
  try {
    var data = {
      experiments: experiments,
      eoe: eoe,
      eligibility: eligibility,
      timestamp: Date.now()
    };
    var expires = new Date(Date.now() + EXPERIMENTS_COOKIE_TTL_MS).toUTCString();
    var domain = isLocalEnv() ? '' : '; domain=.moneyboat.co.uk';
    document.cookie = "".concat(EXPERIMENTS_COOKIE_NAME, "=").concat(encodeURIComponent(JSON.stringify(data)), "; expires=").concat(expires, "; path=/").concat(domain, "; SameSite=Lax");
  } catch (error) {
    console.warn('[Experiments] Failed to set cookie:', error);
  }
};

// ============ Eligibility Helpers ============

export var parseEligibility = function parseEligibility(eligibility) {
  return eligibility ? eligibility.split(',').filter(Boolean) : [];
};
export var hasAllEligibility = function hasAllEligibility(existing, requested) {
  var existingArr = parseEligibility(existing);
  return parseEligibility(requested).every(function (e) {
    return existingArr.includes(e);
  });
};
export var mergeEligibility = function mergeEligibility(existing, newItems) {
  return _toConsumableArray(new Set([].concat(_toConsumableArray(parseEligibility(existing)), _toConsumableArray(parseEligibility(newItems))))).filter(Boolean).join(',');
};